const ACCESS_RULES = {
  4: ['/dashboard', '/3d-model', '/notifications', '/profile', '/sensors'],
  5: ['/pending'],
}

export const getAllowedRoutesForLevel = (level) => {
  const allowed = ACCESS_RULES[level]
  return Array.isArray(allowed) ? allowed : null
}

export const isRouteAllowedForLevel = (level, path) => {
  const allowedRoutes = getAllowedRoutesForLevel(level)
  if (!allowedRoutes) return true
  return allowedRoutes.includes(path)
}

export const getDefaultRouteForLevel = (level) => {
  const allowedRoutes = getAllowedRoutesForLevel(level)
  if (allowedRoutes?.length) {
    return allowedRoutes[0]
  }
  return '/dashboard'
}

export const filterMenuItemsForLevel = (menuItems, level) => {
  const allowedRoutes = getAllowedRoutesForLevel(level)
  if (!allowedRoutes) return menuItems
  return menuItems
    .map((item) => {
      if (item.children) {
        const allowedChildren = item.children.filter((child) =>
          allowedRoutes.includes(child.path)
        )
        if (allowedChildren.length === 0) return null
        return { ...item, children: allowedChildren }
      }
      return allowedRoutes.includes(item.path) ? item : null
    })
    .filter(Boolean)
}
